import React, { Component } from 'react';
import {Area, ResponsiveContainer, ComposedChart, Tooltip, XAxis} from "recharts";
import PropTypes from "prop-types";
import AuthService from "../../lib/AuthService";
class VignetItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: ''
        };
        this.Auth = new AuthService();

    }

    componentDidMount() {

    }

    render() {
        let item = this.props.detail;
        let index = this.props.id;

        item.imgSrc = this.props.pageSettingsData.config.IMGIX_PATH+'assets/slider/cf'+item.uniqueId+'.jpg?fit=crop&h=150&w=150&auto=enhance&dpr=3%203x';

        let graphData =  item.graphData?item.graphData:[];

        item.builderUrl = this.props.pageSettingsData.config.BUILDER_PATH+item.uniqueId+'/'+item.user_id;
        if(item.public_view === 1) {
            item.playerUrl = this.props.pageSettingsData.config.PUB_PLAYER_PATH+ item.vignet_id;
        }
        else{
            item.playerUrl = this.props.pageSettingsData.config.UNPUB_PLAYER_PATH+ item.vignet_id+'//';
        }

        return (
            <li id={"vig-"+index}>
                <div className="list__img overview-main">
                    <a href={item.playerUrl} target="_blank" >  <img
                        src={item.imgSrc}
                        alt={item.vignet_title}
                        className="my-image" /></a>
                    {item.user_id == this.Auth.getProfile().user_id &&
                    <a href={item.builderUrl} target="_blank" >
                        <button className="icon-lib add-button overview-edit-btn">
                        </button>  </a>
                        }
                </div>

                <div className="list__right-content">

                    <div className="list__right--text">
                        <div className="list__right-content--detail">
                            <a href={item.playerUrl} target="_blank" > <h3>{item.vignet_title} </h3></a>
                            <p>{item.display_name?item.display_name.toUpperCase():''}</p>
                            <p>{item.date_created}</p>
                        </div>
                        <div className="list__right-content--count">
                            <div className="count__item">
                                <p>CLICKS</p>
                                <h4><span>{item.click_count?item.click_count:0}</span></h4>
                            </div>
                            <div className="count__item">
                                <p>VIEWS</p>
                                <h4><span>{item.view_count?item.view_count:0}</span></h4>
                            </div>
                        </div>
                    </div>
                    <div className="list__right-content-bottom">

                    <div className="list__right-content--graph">
                        <div className="right-content__graph-section">
                            <ResponsiveContainer width={212} height={46} aspect="width">
                                <ComposedChart  data={graphData} >
                                    <Area name="views" type="monotone" dataKey="Visits" fill="#45ace3" stroke="#45ace3" />
                                    <Tooltip active={false} />
                                    <XAxis name="" dataKey="name" tick={false} hide={true}/>
                                </ComposedChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                    </div>

                </div>
                {/*<div className="list__link">*/}
                {/*    <a href="javascript:void(0);">VIEW FORECAST</a>*/}
                {/*</div>*/}
            </li>
        )
    }

}

VignetItem.propTypes = {
    detail: PropTypes.object.isRequired,
    id:PropTypes.number.isRequired
}
export default VignetItem;



// WEBPACK FOOTER //
// ./src/components/overview/VignetItem.js